
async function nodeWorker(url: URL, parameters?: Record<string, string>, options?) {
    const {NodeWorker} = await import('./nodeWorker.js');
    const args = Object.entries(parameters ?? {}).map(([k,v]) => `--${k}=${v}`);
    return new NodeWorker(url, args, options);
}

async function webWorker(url: URL, parameters?: Record<string, string>, options?: & WorkerOptions) {
    Object.entries(parameters ?? {}).forEach(([k, v]) => url.searchParams.append(k, v));
    return new Worker(url, options);
}

export function newWorker({url, parameters, options}: {url: URL, parameters?: Record<string, string>, options?: unknown}): Promise<Worker> {
    return (
        typeof process !== 'undefined'
            ? nodeWorker(url, parameters, options)
            : webWorker(url, parameters, options as WorkerOptions))
    ;
}
